import toStr from "./format";

interface TimeSlot {
	start: string | Date;
	end: string | Date;
}

interface TimeRange {
	start: string;
	end: string;
}

interface DateRanges {
	[date: string]: string[];
}

const slotToRange = (data: TimeSlot[]): DateRanges => {
	if (!data.length) return {};

	// Remove duplicates and sort by start time
	const uniqueSlots = Array.from(new Map(data.map(slot => [new Date(slot.start).getTime(), slot])).values()).sort(
		(a, b) => new Date(a.start).getTime() - new Date(b.start).getTime(),
	);

	const dateGroups: { [date: string]: TimeRange[] } = {};

	for (const slot of uniqueSlots) {
		const startDate = new Date(slot.start);
		const endDate = new Date(slot.end);

		const dateKey = toStr(startDate, "DD MMM'YY");
		const startTime = toStr(startDate, "hA");
		const endTime = toStr(endDate, "hA");

		if (!dateGroups[dateKey]) {
			dateGroups[dateKey] = [];
		}

		const ranges = dateGroups[dateKey];
		const lastRange = ranges[ranges.length - 1];

		// Merge consecutive time slots
		if (lastRange && lastRange.end === startTime) {
			lastRange.end = endTime;
		} else {
			ranges.push({ start: startTime, end: endTime });
		}
	}

	// Format as "startTime-endTime" strings
	return Object.entries(dateGroups).reduce((result, [date, ranges]) => {
		result[date] = ranges.map(range => `${range.start}-${range.end}`);
		return result;
	}, {} as DateRanges);
};

export default slotToRange;
